<template>
  <div>
    <b-row v-if="editedEntity">
      <b-col md="6">
        <letter-avatar :name="editedEntity.name" :image="editedEntity.avatar" variant="secondary" />
        <h3 class="ml-5">
          {{ editedEntity.name }}
          <br />
          <span class="font-size-14 text-muted">
            {{ editedEntity.email }}
          </span>
        </h3>
      </b-col>
      <b-col md="5">
        <letter-avatar :name="selectedOrganization.name" :image="selectedOrganization.logo" variant="secondary" />
        <h5 class="ml-5 text-muted">
          {{ selectedOrganization.name }}
          <br />
          <span class="font-size-14 ">
            <i class="mdi mdi-hexagon-multiple-outline mr-1"></i>
            {{ selectedOrganization.workspace.name }}
          </span>
        </h5>
      </b-col>
    </b-row>

    <hr />

    <!-- <b-form-checkbox switch size="sm" v-model="form.accessable"> {{ $t("organization.can-access") }}</b-form-checkbox> -->

    <h3 class="mt-4">{{ $t("role.plural") }}</h3>

    <div v-if="roles">
      <div
        v-for="item in filteredRoles"
        :key="item._id"
        @click="selectRole(item)"
        :class="selectionMap[item._id] ? 'border-primary bg-soft-primary' : 'border-gray'"
        class="mb-1 p-2 card card-body hand border "
      >
        <b class="text-primary">{{ item.name | translate }}</b>
        <div>
          {{ item.description | translate }}
        </div>

        <h6 class="mt-3">{{ $t("role.permissions") }}</h6>

        <div
          class="card card-body bg-light border border-secondary mb-1 p-1 text-muted"
          v-for="p in item.permissions"
          :key="item._id + p.definition"
          v-b-tooltip.hover
          :title="$options.filters.translate(p.description)"
        >
          {{ p.name | translate }}
        </div>
      </div>
    </div>
    <empty v-if="!filteredRoles || filteredRoles.length == 0" width="120px">
      <h6 class="text-center">
        {{ $t("organization.members.empty-accessible-roles") }}
      </h6>
    </empty>

    <sweet-button
      v-if="filteredRoles && filteredRoles.length"
      @click="save()"
      type="submit"
      :loading="isUpdating"
      variant="success"
      icon="mdi mdi-check"
      size="sm"
      buttonClass="mt-2"
    >
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      form: {},
      selections: [],
      selectionMap: {},
    };
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.resetForm();
        if (v) {
          this.form = { ...v };

          if (v.roles) {
            v.roles.forEach((i) => this.selectRole(i));
          }
        }
      },
    },
  },
  computed: {
    editedEntity() {
      return this.$store.getters["organizationMember/editedEntity"];
    },
    selectedOrganization() {
      return this.$store.getters["organization/selected"];
    },
    roles() {
      return this.$store.getters[`role/pagination`];
    },
    filteredRoles() {
      const ac = this.accessableRoles.map((i) => i._id);

      return this.roles?.docs?.filter((role) => ac.includes(role._id)) || [];
    },
    accessableRoles() {
      return this.$store.getters["user/accessableRoles"] || [];
    },
    isUpdating() {
      return this.$store.getters["organizationMember/isUpdating"];
    },
  },
  mounted() {
    this.$store.dispatch(`role/paginate`, {
      options: { page: 1, limit: 500, sort: { name: "asc" } },
    });
  },
  methods: {
    selectRole(item) {
      if (this.selectionMap[item._id]) {
        delete this.selectionMap[item._id];
        this.selections = [...this.selections.filter((i) => i._id != item._id)];
      } else {
        this.selections = [...this.selections, item];
        this.selectionMap[item._id] = item;
      }
      this.$forceUpdate();
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationMember/save`, {
          ...this.form,
          memberId: this.form._id,
          roles: this.selections,
        });
        this.resetForm();
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", "sidebar-member-form");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    resetForm() {
      this.form = {};
      this.selections = [];
      this.selectionMap = {};
    },
  },
};
</script>
